import { inject, provideAppInitializer, EnvironmentProviders } from '@angular/core';
import { AuthentificationService } from '@services/authentification/authentification.service';

export function authInitializeApp(authentificationService: AuthentificationService) {
  const customEventSessionComplete = '@authentification/v1/chargement-session-complete';

  return (): Promise<void> => {
    return new Promise((resolve) => {
      const cleanListener = () => {
        globalThis.removeEventListener(customEventSessionComplete, completeSession);
      };
      const completeSession = () => {
        cleanListener();
        resolve();
      };

      globalThis.addEventListener(customEventSessionComplete, completeSession);
      authentificationService.initialiser();
    });
  };
}

export const AUTH_INITIALIZER_MODULE: EnvironmentProviders = provideAppInitializer(() => {
  const initializerFn = authInitializeApp(inject(AuthentificationService));
  return initializerFn();
});
